
    <div class="page-center-wrapper">

        <div [ngClass]="getClasses()" [ngStyle]="getStyles()"  theme [styleObj]='brandStyleTheme'>

            <div class="card" style="background-color: transparent;">

            <div class="card-header" #panelHeading style="background-color: transparent;" [ngClass]="{'wp-freeze-block': isHeaderFrozen}">

                <ng-template headerSection></ng-template>

            </div>

            <div [ngClass]="{'wp-scrollable-content': isHeaderFrozen}" class="panel-content" #panelContent>

                <div class="card-body">

                    <ng-template bodySection></ng-template>
        
                </div>

                <div class="card-footer" style="background-color: transparent;">

                    <div class="row justify-content-center">
                        
                        <div class="col-12 col-lg-6">  

                            <ng-template footerSection></ng-template>

                        </div>
        
                    </div>
        
                </div>

            </div>

        </div>

    </div>


